import React, { Component } from 'react'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Config from '../../commons/config/Config.js'
import Dialog from '../../commons/dialog/Dialog.js'
import DropzoneComponent from 'react-dropzone-component/dist/react-dropzone'
import $ from 'jquery'
import Select from 'react-select'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class CorrectivosAbmAdjuntos extends Component {
	constructor(props) {
		super(props);
		this.props = props;

		this.ajaxHandler = new AjaxHandler();

		this.state = {
			adjuntos: [{
					id: -1,
					nombre: this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.file_add.section.sin_categoria', defaultMessage: 'Sin categoría' }),
					adjuntos: []
				}
			],
			categoria: null,
			categorias: [],
			tabSelected: -1
		};

		this.selectTab = this.selectTab.bind(this);
		this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
		this.handleViewAdjunto = this.handleViewAdjunto.bind(this);
		this.handleRemoveAdjunto = this.handleRemoveAdjunto.bind(this);

		this.initFileUpload();
	}

	componentDidMount() {
		this.ajaxHandler.subscribe(this);
		this.initForm();
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	initForm() {
		let component = this;
		Promise.all([
			this.ajaxHandler.getJson('/categorias/select')
		]).then((data) => {
			let categorias = data[0] ? data[0] : [];
			categorias.unshift({value: -1, label: this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.file_added.section.sin_categoria', defaultMessage: 'Sin categoría' })});

			component.setState({
				categorias: categorias
			});
		}).catch(function(error) {
			console.log(error);
		}).finally(() => {
		});
	}

	initFileUpload() {
		let component = this;

		this.fileUploadConfig = {
			showFiletypeIcon: false,
			postUrl: Config.get('apiUrlBase') + '/tickets/adjunto'
		};

		this.fileUploadDjsConfig = {
			addRemoveLinks: false,
			thumbnailMethod: 'crop',
			dictDefaultMessage: this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.add_file.information.haga_click_o', defaultMessage: 'Haga click aquí o' })+"<br>"+this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.add_file.information.arrastre_archivo_este_area', defaultMessage: 'arrastre un archivo a este área' })+"<br>"+this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.add_file.information.para_cargarlo_categoría_seleccionada', defaultMessage: 'para cargarlo en la categoría seleccionada.'})+'<br>'+component.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.add_file.tamano_maximo_archivo_archivo_20mb', defaultMessage: 'Tamaño máximo de archivo 20MB.' }),
			uploadMultiple: true,
			maxFilesize: 20,
			parallelUploads: 1,
			headers: {
				"Authorization-Token": localStorage.getItem("token")
			},
			previewTemplate: `
		        <div class="dz-preview dz-image-preview">
		          <div class="dz-image">
		            <img data-dz-thumbnail src="/images/file.png" />
		          </div>
		          <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress="" style="width: 0%;"></span></div>
		          <div class="dz-success-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>      </g>    </svg>
		          </div>
		          <div class="dz-error-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>        </g>      </g>    </svg>
		          </div>
		          <div class="dz-error-message"><span data-dz-errormessage></span></div>
		        </div>
		    `,
			init: function() {
				let dropzone = this;

				this.on('success', (file, response) => {
					this.removeFile(this.files[0]);

					let adjuntos = component.state.adjuntos;
					let categoriaId = component.state.categoria ? component.state.categoria : -1;
					let categoria = component.state.categorias.find(e => e.value === categoriaId);

					let adjuntosCategoria = adjuntos.filter(e => e.id === categoriaId);
					if(!adjuntosCategoria.length) {
						adjuntos.push({
							id: categoria.value,
							nombre: categoria.label,
							adjuntos: [{
								adjunto: response.archivo, 
								archivoNombre: file.name
							}]
						});
					} else {
						adjuntosCategoria.map(e => e.adjuntos.push({
							adjunto: response.archivo, 
							archivoNombre: file.name
						}));
					}

					component.setState({
						adjuntos: adjuntos,
						tabSelected: categoriaId
					});

					component.props.callbackUpdate(adjuntos);
				});

				this.on('error', (file, errormessage, response) => {
					dropzone.removeFile(file);
					let title;
					let text;
					if(errormessage.includes('files of this type')){	
						title = component.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.add_file.errors.formato_archivo_invalido', defaultMessage: 'Formato de archivo inválido' })
						text = ' '; // para prevenir que aparezca el text contacte al adm
					}else if(errormessage.includes('File is too big')){
						title = component.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.add_file.errors.el_archivo_es_demasiado_grande', defaultMessage: 'No se pudo subir el archivo. El mismo supera el tamaño máximo de 20 MB' })
						text = ' '; // para prevenir que aparezca el text contacte al adm
					}else {
						title = component.props.intl.formatMessage({id: 'correctivosAbmAdjuntos.adjuntos.add_file.errors.error_cargar_archivo.', defaultMessage: 'Error al cargar el archivo.' })
						text = ''; // para prevenir que aparezca el text contacte al adm
					}
					Dialog.alert(component.props.intl, {
						title: title,
						text: text
					});					
				});
			}
		};

		this.fileUploadHandlers = {
			init: dz => {
				this.adjuntosDropzone = dz;
			}
		};
	}

	selectTab(categoria, e) {
		this.setState({
			tabSelected: categoria
		});
	}

	handleCategoriaChange(categoria) {
		this.setState({
			categoria: categoria ? categoria.value : null
		});
	}

	handleViewAdjunto(e, adjunto) {
		this.ajaxHandler.fetch('/tickets/adjunto/' + adjunto, {
			method: 'GET'
		}).then(response => {
			if (response.status === 200) {
				return response.blob();
			}
		}).then(fileBlob => {
			// HOTPATCH VEC-4158: window.open() dejaba que el navegador decida
			// previsualizar o descargar -- si decide previsualizar (visor de PDF
			// propio del navegador), su boton de descarga interno no respeta el
			// nombre del archivo. Se fuerza la descarga directa via <a download>
			// para garantizar nombre+extension correctos siempre.
			const namedFile = new File([fileBlob], adjunto, { type: fileBlob.type });
			let fileUrl = URL.createObjectURL(namedFile);
			const link = document.createElement('a');
			link.href = fileUrl;
			link.download = adjunto;
			link.click();
		}).catch(() => {});
		e.preventDefault();
	}

	handleRemoveAdjunto(e, adjunto) {
		this.ajaxHandler.fetch('/tickets/adjunto/' + adjunto, {
			method: 'DELETE'
		}).then(response => {
			let adjuntos = this.state.adjuntos;
			let categoria = adjuntos.filter(categoria => categoria.id === this.state.tabSelected)[0];
			categoria.adjuntos = categoria.adjuntos.filter(a => a.adjunto !== adjunto);
			let tabSelected = this.state.tabSelected;
			if(!categoria.adjuntos.length) {
				adjuntos = adjuntos.filter(c => c.id !== categoria.id);
				tabSelected = adjuntos.length ? adjuntos[0].id : -1;
			}

			this.setState({
				adjuntos: adjuntos,
				tabSelected: tabSelected
			});

			this.props.callbackUpdate(adjuntos);
		}).catch(() => {});
		e.preventDefault();
	}

	render() {
		let state = this.state;
		let categoria = state.categoria ? state.categorias.find(e => e.value === state.categoria) : null;

		return (
			<React.Fragment>					
				<div className="card pull-up">
					<div className="card-content pl-1 pr-1">
						<div className="card-body">
							<h4 className="form-section">
								<i className="la la-file"></i><FormattedMessage id="correctivosAbmAdjuntos.adjuntos.information" defaultMessage=" Adjuntos"/>
							</h4>

							<div className="row chat-application ml-0 mr-0 mb-1" style={{border: 0}}>
								<div className="content-body">

									<div className="row">
										<div className="col-md-6 pt-1">
											<div className="form-group row">
												<label className="col-md-4 label-control col-form-label text-nowrap" htmlFor="categoria">
													<FormattedMessage id="correctivosAbmAdjuntos.adjuntos.information.categoria" defaultMessage="Categoría:"/>
												</label>
												<div className="col-md-8 ">
													<div>
														<Select
															id="categoria"
															name="categoria"
															placeholder={this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.placeholder.categoria', defaultMessage: 'Seleccione' })}
															options={this.state.categorias}
															valueKey='value'
															labelKey='label'
															className="select-adjuntos"
															value={categoria}
															onChange={(e) => this.handleCategoriaChange(e)}
														/>
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-6">
											<DropzoneComponent id="archivos" config={this.fileUploadConfig} eventHandlers={this.fileUploadHandlers} djsConfig={this.fileUploadDjsConfig} />
										</div>

										<hr/>
									</div>

									<div className="row mt-1">
										<div className="col-md-12">
											{this.state.adjuntos.filter(categoria => categoria.adjuntos && categoria.adjuntos.length).length ? (
											<React.Fragment>
												<ul className="nav nav-tabs no-hover-bg nav-justified nav-topline">
													{this.state.adjuntos.filter(categoria => categoria.adjuntos && categoria.adjuntos.length).sort((x, y) => x.id === -1 ? -1 : y.id === -1 ? 1 : x.nombre <= y.nombre ? -1 : 1).map((categoria, index) => (
														<li key={categoria.id} className="nav-item">
															<a className={'nav-link' + (categoria.id === this.state.tabSelected ? ' active' : '')} id={categoria.id} data-toggle="tab" href={'#'+categoria.id} aria-expanded="true" onClick={(e) => this.selectTab(categoria.id, e)} style={categoria.id === -1 ? {fontWeight: 'bold'} : {}}>{categoria.nombre}</a>
														</li>
													))}
												</ul>

												<div className="tab-content px-1 pt-1">
													{this.state.adjuntos.filter(categoria => categoria.adjuntos && categoria.adjuntos.length).sort((x, y) => x.id === -1 ? -1 : y.id === -1 ? 1 :x.nombre <= y.nombre ? -1 : 1).map((categoria, index) => (
														<div key={categoria.id} role='tabpanel' className="tabpanel" id={categoria.id} aria-labelledby="link-tab" aria-expanded="true" hidden={categoria.id !== this.state.tabSelected}>

															<table className="table">
																<tbody style={{maxHeight: '200px', overflowY: 'auto', display: 'block'}}>
																	{categoria.adjuntos.map((adjunto, index) => (
																	<tr key={index}>
																		<td className="align-middle">{adjunto.archivoNombre}</td>
																		<td className="align-middle">
																			<button className="action btn btn-icon text-fleet btn-sm btn-dt-grid p-0 m-0" onClick={(e) => this.handleViewAdjunto(e, adjunto.adjunto)} title={this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.file_added.button_title.ver_adjunto', defaultMessage: 'Ver Adjunto' })} >
																				<i className="fa fa-paperclip fa-xs"></i>
																			</button>
																		</td>
																		<td className="align-middle">
																			<button className="action btn btn-icon text-fleet text-danger btn-sm btn-dt-grid p-0 m-0" onClick={(e) => this.handleRemoveAdjunto(e, adjunto.adjunto)} title={this.props.intl.formatMessage({ id: 'correctivosAbmAdjuntos.adjuntos.file_added.button_title.eliminar', defaultMessage: 'Eliminar' })} >
																				<i className="fa fa-trash fa-xs"></i>
																			</button>
																		</td>
																	</tr>
																	))}
																</tbody>
															</table>
														</div>
													))}
												</div>
											</React.Fragment>
											) : (
												<div><FormattedMessage id="correctivosAbmAdjuntos.adjuntos.no_hay_archivos_adjuntos_cargados" defaultMessage="No hay archivos adjuntos cargados."/></div>
											)}
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
			
		);
	}
}

export default injectIntl(CorrectivosAbmAdjuntos);
